import { ValeurSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const ValeurModel: SelectorModel = {
  name: 'valeurs',
  getSelector: ValeurSelectors.selectAllValeursDictionary,
  isReady: ValeurSelectors.selectIsReadyValeur
};
